import { Skeleton, Stack, StackProps, Grid, Card, CardContent } from "@mui/material";
import useBreakpoints from "hooks/useBreakpoint";

const BuyerSkeleton = (props: StackProps) => {
  const { isMobile } = useBreakpoints();

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        position: "relative",
        height: "100%",
        width: "100%",
        boxShadow: "none",
        borderRadius: 2,
        px: 1.5,
        py: 1,
      }}
    >
      <CardContent sx={{ p: 0, pb: "0!important" }}>
        <Grid container spacing={1}>
          {/* Left Column */}
          <Grid item xs={isMobile ? 12 : 9}>
            <Stack gap={1.5}>
              {/* Company Header Row */}
              <Stack gap={1} flex={1} overflow="hidden" width="100%">
                {/* Header */}
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Skeleton variant="circular" height={24} width={24} />
                  <Stack direction="row" gap={1}>
                    <Skeleton variant="text" height={20} width={60} />
                    <Skeleton variant="text" height={20} width={60} />
                  </Stack>
                  <Stack direction="row" gap={1}>
                    <Skeleton variant="text" height={20} width={80} />
                    <Skeleton variant="text" height={20} width={80} />
                  </Stack>
                </Stack>

                <Skeleton variant="rectangular" height={1} width="100%" />

                {/* Company Info */}
                <Stack gap={0.5} flexDirection="row" justifyContent="space-between">
                  <Stack direction="row" gap={0.5} flex={1}>
                    <Skeleton variant="circular" height={40} width={40} />
                    <Stack flex={1}>
                      <Skeleton variant="text" height={20} width="70%" />
                      <Skeleton variant="text" height={20} width="100%" />
                      <Skeleton variant="text" height={20} width="50%" />
                    </Stack>
                  </Stack>
                  <Skeleton variant="circular" height={32} width={32} />
                </Stack>

                {/* Buying Lead Info */}
                <Stack flexDirection="row" gap={0.5} alignItems="center">
                  <Skeleton variant="text" height={20} width="30%" />
                  <Skeleton variant="text" height={20} width="60%" />
                </Stack>

                {/* Description */}
                <Stack gap={0.5}>
                  <Skeleton variant="text" height={20} width="100%" />
                  <Skeleton variant="text" height={20} width="85%" />
                </Stack>

                {/* Attributes */}
                <Stack direction="row" gap={1} flexWrap="wrap">
                  <Skeleton variant="text" height={20} width={120} />
                  <Skeleton variant="text" height={20} width={100} />
                  <Skeleton variant="text" height={20} width={140} />
                </Stack>

                {/* Country and Action Buttons */}
                <Stack direction="row" justifyContent="space-between">
                  <Stack direction="row" gap={1} alignItems="center">
                    <Skeleton variant="text" height={20} width={80} />
                    <Skeleton variant="circular" height={24} width={24} />
                  </Stack>
                  {!isMobile && (
                    <Stack direction="row" gap={1}>
                      <Skeleton variant="rectangular" height={36} width={120} />
                      <Skeleton variant="rectangular" height={36} width={140} />
                    </Stack>
                  )}
                </Stack>

                {/* Categories */}
                <Stack direction="row" gap={1} flexWrap="wrap">
                  <Skeleton variant="text" height={20} width={60} />
                  <Skeleton variant="text" height={20} width={80} />
                  <Skeleton variant="text" height={20} width={70} />
                </Stack>
              </Stack>

              {/* Mobile Footer */}
              {isMobile && (
                <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
                  <Stack direction="row" gap={1} flex={1}>
                    <Skeleton variant="circular" height={40} width={40} />
                    <Stack flex={1}>
                      <Skeleton variant="text" height={20} width="60%" />
                      <Skeleton variant="text" height={20} width="40%" />
                    </Stack>
                  </Stack>
                  <Stack direction="row" gap={1}>
                    <Skeleton variant="rectangular" height={36} width={120} />
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Grid>

          {/* Right Column - Only shows on desktop */}
          {!isMobile && (
            <Grid item md={3} display={{ xs: "none", md: "block" }}>
              <Stack gap={1}>
                <Stack alignSelf="flex-end">
                  <Skeleton variant="text" height={20} width={80} />
                </Stack>
                <Stack gap={1}>
                  <Stack direction="row" gap={1}>
                    <Skeleton variant="circular" height={40} width={40} />
                    <Stack flex={1}>
                      <Skeleton variant="text" height={20} width="70%" />
                      <Skeleton variant="text" height={20} width="50%" />
                    </Stack>
                  </Stack>
                  <Stack direction="row" gap={1} flexWrap="wrap">
                    <Skeleton variant="text" height={20} width={100} />
                    <Skeleton variant="text" height={20} width={80} />
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

// const StyledBuyerSkeleton = styled(Stack)(({ theme }) => ({
//   backgroundColor: "#fff",
//   borderRadius: 8,
//   border: "1px solid #eaecf0",

//   [theme.breakpoints.down("md")]: {
//     padding: 8,
//   },
// }));

export default BuyerSkeleton;
